module.exports = __webpack_public_path__ + "_assets/img/map.897c3d77.svg";